import { gql } from "@apollo/client";

export const GET_BOOKING_SUMMARY_PDF = gql`
   query booking($id: String!) {
    booking(id: $id) {
      bookingConfirmationUrl
    }
  }
`;
